import React, {ChangeEvent} from "react";
import {OPERATIONS, OperationType} from "../../../../../models/formulas";
import {MenuItem, Select} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import {useTranslation} from "react-i18next";

interface FormulaOperationSelectProps {
    value: OperationType;
    onChange: (operation: OperationType) => void;
}

const useStyles = makeStyles((theme) => ({
    list: {
        minWidth: "5em",
        maxWidth: "30em",
    },
    listItem: {
        whiteSpace: "normal",
        maxWidth: "30em",
    },
}));

export const FormulaOperationSelect: React.FC<FormulaOperationSelectProps> = (props: FormulaOperationSelectProps) => {
    //== Init =================================================================
    const classes = useStyles();
    const [t] = useTranslation("libraries");
    //== Handlers =============================================================
    const handleChange = (event: ChangeEvent<{name?: string; value: unknown}>) => {
        props.onChange(event.target.value as OperationType);
    };
    //== Render ===============================================================
    return (
        <Select value={props.value.valueOf()} onChange={handleChange} className={classes.list}>
            {OPERATIONS.map((o) => (
                <MenuItem key={o.type.valueOf()} value={o.type.valueOf()} className={classes.listItem}>
                    {t(`formula.info.${o.type.valueOf()}`)}
                </MenuItem>
            ))}
        </Select>
    );
};
